"use client";

import { useEffect } from "react";
import { ErrorLogService, ErrorSeverity } from "@/services/errorLog";

export default function ErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    void ErrorLogService.logError(error, {
      component: "app/error.tsx",
      severity: ErrorSeverity.CRITICAL,
      extra_data: {
        digest: error.digest,
      },
    });
  }, [error]);

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-white">
      <div className="max-w-md w-full rounded-xl border border-red-200 bg-white p-6 text-center shadow-lg">
        <h1 className="text-xl font-bold text-red-700 mb-2">Algo deu errado</h1>
        <p className="text-sm text-slate-700 mb-5">
          Tivemos um erro inesperado. Você pode tentar novamente agora.
        </p>
        <button
          type="button"
          onClick={reset}
          className="w-full rounded-lg px-4 py-2 text-white font-semibold bg-emerald-700 hover:bg-emerald-800 transition-colors"
        >
          Tentar novamente
        </button>
      </div>
    </div>
  );
}
